import {Component, Input, OnChanges, OnInit, ViewChild, inject, DestroyRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {StoreService} from '../../../services/http/store/store.service';
import {StoreSortService} from '../../../services/store/store-sort.service';
import {DataService} from '../../../services/store/data.service';
import {StoreSummary} from '../../../classes/models/store/StoreSummary';
import moment from 'moment';
import {map} from 'rxjs/operators';
import {ChangeStoreService} from '../../../services/store/change-store.service';

/**
 * This component handles searching for a store with autocomplete.
 */
@Component({
  selector: 'app-store-search',
  templateUrl: './store-search.component.html',
  styleUrls: ['./store-search.component.less'],
  imports: [CommonModule, FormsModule, AutocompleteLibModule]
})
export class StoreSearchComponent implements OnInit, OnChanges {
  private storeService = inject(StoreService);
  private storeSortService = inject(StoreSortService);
  dataService = inject(DataService);
  private changeStoreService = inject(ChangeStoreService);
  private destroy$ = new Subject<void>();

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** The store, which is currently selected. */
  @Input() selectedStore: StoreSummary;
  /** An autocomplete search element in HTML. */
  @ViewChild('autocomplete') autocomplete;

  /**
   * Retrieves all stores from backend and sets up a week range to show predictions and rotas.
   */
  ngOnInit(): void {
    this.getStores();
    this.dataService.rangeFrom = moment().weekday(0).format('YYYY-MM-DD');
    this.dataService.rangeTo = moment().add(5, 'weeks').weekday(6).format('YYYY-MM-DD');
  }

  /**
   * Clears autocomplete search if there is no selected store.
   */
  ngOnChanges(): void {
    if (this.autocomplete && !this.selectedStore) {
      this.autocomplete.clear();
    }
  }

  /**
   * Changes the selected store.
   * @param store a store, which was selected.
   */
  storeSelected(store: StoreSummary): void {
    if (this.selectedStore && this.selectedStore.name === store.name) {
      return;
    }
    this.changeStoreService.selectStore(store);
  }

  private getStores(): void {
    this.storeService.all()
            .pipe(
                    map(stores => this.storeSortService.sortByName(stores)),
                    takeUntil(this.destroy$)
            )
            .subscribe({
              next: stores => this.dataService.stores = stores
            });
  }

  /**
   * Unsets the selected store.
   */
  clearSelection() {
    this.changeStoreService.unselectStore();
  }
}
